import { LocaleMessages } from 'vue-i18n'

const docEnUsLocaleMessages: LocaleMessages = {
  dfeXml: {
    title: 'DF-e XML',
    pluralTitle: 'DF-e XMLs',
    field: {
      tipo: 'Type',
      operacao: 'Operation',
      dataHora: 'Date and time',
      timeZoneOffset: 'Time zone',
      serie: 'Series',
      numero: 'Number',
      chave: 'Key',
      valor: 'Value',
      inscricaoEmitente: 'Issuer',
      inscricaoDestinatario: 'Recipient',
      inscricaoTransportador: 'Transporter',
      tamanho: 'Size',
      checksum: 'Checksum',
      inscricao: 'Registry',
      periodo: 'Period',
      pluralTipo: 'Types',
      pluralOperacao: 'Operations'
    },
    alert: {
      download: 'Enter a registry and a period to download all XMLs at once.'
    },
    value: {
      tipo: {
        NFE: 'NF-e',
        NFE_CANCELADO: 'NF-e (Canceled)',
        NFE_DENEGADO: 'NF-e (Denied)',
        CTE: 'CT-e',
        CTE_CANCELADO: 'CT-e (Canceled)',
        CTE_DENEGADO: 'CT-e (Denied)',
        CTEOS: 'CT-e OS',
        CTEOS_CANCELADO: 'CT-e OS (Canceled)',
        CTEOS_DENEGADO: 'CT-e OS (Denied)',
        NFSE: 'NFS-e',
        NFSE_CANCELADO: 'NFS-e (Canceled)',
        NFCE: 'NFC-e',
        NFCE_CANCELADO: 'NFC-e (Canceled)',
        NFCE_DENEGADO: 'NFC-e (Denied)',
        SAT: 'SAT',
        SAT_CANCELADO: 'SAT (Canceled)'
      },
      operacao: {
        ENTRADA: 'In',
        SAIDA: 'Out'
      }
    }
  },
  dfeXmlUserContext: {
    title: 'DF-e XML of User',
    pluralTitle: 'DF-e XMLs of User'
  }
}

export default docEnUsLocaleMessages